import Heading from '../components/common/Heading';
import LayOut from '../components/common/Layout';
import UnspokenThings from '../components/unspokenThings/UnspokenThings';
import Edition1Cover from '../assets/images/Art_Book_Cover_Edition_1.jpg';
import Edition2Cover from '../assets/images/Art_Book_Cover_Edition_2.jpg';
import { Link } from 'react-router-dom';
import { Routes } from '../utils/Routes';

export default function Things() {
  return (
    <LayOut layoutStyle="bg-white">
      <div className="pt-16 md:pt-10 lg:pt-14">
        <Heading text="Unspoken Things" customStyle="text-custom-coffee" />
        <div className="mx-auto mt-3 w-10 h-px bg-custom-stone" />

        {/* Art Book Publications Banner */}
        <div className="mx-auto max-w-2xl px-4 mt-6">
          <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-md bg-stone-50">
            {/* Header */}
            <div className="px-6 pt-5 pb-3 text-center">
              <p className="text-xs tracking-[0.2em] uppercase text-gray-400 font-medium">
                Art Books Collection
              </p>
              <div className="mx-auto mt-2 w-6 h-px bg-custom-stone/50" />
            </div>

            {/* Editions */}
            <div className="flex justify-center gap-6 sm:gap-10 px-6 pb-5">
              {/* Edition I */}
              <div className="flex flex-col items-center gap-3">
                <Link
                  to={`${Routes.ArtPublication}?edition=1`}
                  className="group block"
                >
                  <div className="relative">
                    <img
                      src={Edition1Cover}
                      alt="Unspoken Art Edition I"
                      className="w-28 sm:w-36 aspect-[3/4] object-cover rounded-lg shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1"
                    />
                    <div className="absolute inset-0 rounded-lg ring-1 ring-black/10" />
                  </div>
                </Link>
                <div className="text-center">
                  <p className="text-sm font-semibold text-custom-coffee">
                    Edition I
                  </p>
                </div>
                <Link to={`${Routes.ArtPublication}?edition=1`}>
                  <span className="inline-flex items-center gap-1.5 border border-custom-coffee/40 text-custom-coffee hover:bg-custom-coffee hover:text-white rounded-full px-5 py-1.5 text-xs font-medium transition-all duration-300">
                    Preview
                  </span>
                </Link>
              </div>

              {/* Divider */}
              <div className="w-px bg-gray-200 self-stretch my-2 hidden sm:block" />

              {/* Edition II */}
              <div className="flex flex-col items-center gap-3">
                <Link
                  to={`${Routes.ArtPublication}?edition=2`}
                  className="group block"
                >
                  <div className="relative">
                    <img
                      src={Edition2Cover}
                      alt="Unspoken Art Edition II"
                      className="w-28 sm:w-36 aspect-[3/4] object-cover rounded-lg shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1"
                    />
                    <div className="absolute inset-0 rounded-lg ring-1 ring-black/10" />
                  </div>
                </Link>
                <div className="text-center">
                  <p className="text-sm font-semibold text-custom-coffee">
                    Edition II
                  </p>
                </div>
                <Link to={`${Routes.ArtPublication}?edition=2`}>
                  <span className="inline-flex items-center gap-1.5 border border-custom-coffee/40 text-custom-coffee hover:bg-custom-coffee hover:text-white rounded-full px-5 py-1.5 text-xs font-medium transition-all duration-300">
                    Preview
                  </span>
                </Link>
              </div>
            </div>

            {/* Footer note */}
            <div className="border-t border-gray-200 px-6 py-3 bg-white/60 text-center">
              <p className="text-xs text-gray-400 italic">
                Art books available in selected stores.
              </p>
            </div>
          </div>
        </div>

        <section>
          <UnspokenThings />
        </section>
      </div>
    </LayOut>
  );
}
